import { Box, Chip, Stack, Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { hasPermission } from 'store'
import 'utils/global.scss'

export const basePath = '/needs-attention'

export const tabConfig = [
  { index: 0, label: 'Address Changes', path: 'address-change', permission: 'miscellaneous.needs-attention' },
  { index: 1, label: 'Missing Contact', path: 'missing-contact', permission: 'miscellaneous.needs-attention' },
]

export default function NeedsAttentionTabs() {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { '*': tabName = '' } = useParams()

  const addressChanges = useSelector(state => state.needsAttention.addressChange.list)
  const missingContacts = useSelector(state => state.needsAttention.missingContact.list)

  const counts = {
    'address-change': addressChanges?.filter(item => item.status === 'pending').length ?? 0,
    'missing-contact': missingContacts?.length ?? 0,
  }

  const permittedTabs = tabConfig.filter(tab => hasPermission(tab.permission))
  const tabIndex = permittedTabs.find(tab => tab.path === tabName.split('/')[0])?.index ?? permittedTabs[0]?.index ?? 0

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
      <Tabs value={tabIndex}>
        {permittedTabs.map(tab => (
          <Tab
            key={tab.path}
            sx={{ color: tabIndex === tab.index && 'primary !important' }}
            className={tabIndex === tab.index ? 'tab-item-selected' : `tab-item-${theme}`}
            label={
              counts[tab.path] > 0 ? (
                <Stack direction="row" alignItems="center" spacing={0.75}>
                  <span>{t(tab.label)}</span>
                  <Chip
                    label={counts[tab.path]}
                    color="error"
                    size="small"
                    sx={{ height: 18, minWidth: 18, fontSize: 11, '& .MuiChip-label': { px: 0.75 } }}
                  />
                </Stack>
              ) : (
                t(tab.label)
              )
            }
            value={tab.index}
            component={Link}
            to={`${basePath}/${tab.path}`}
          />
        ))}
      </Tabs>
    </Box>
  )
}
